/**
 * Created by slava on 9/8/17
 */

const FieldBoosters = function () {
    cleverapps.EventEmitter.call(this);
    this.active = undefined;

    this.list = cleverapps.boosters.listBoosters();

    this.list.forEach(function (booster) {
        booster.onExecuteListener = function () {
            this.onExecuteListener();
        }.bind(this);
    }, this);

    cleverapps.eventBus.on("openWindow", () => {
        this.setActive(undefined);
    }, this);

    this.onSetActiveListener = function () {};
    this.onExecuteListener = function () {};
    this.onGetBoosterView = function () {};
};

FieldBoosters.prototype = Object.create(cleverapps.EventEmitter.prototype);
FieldBoosters.prototype.constructor = FieldBoosters;

FieldBoosters.prototype.stop = function () {
    runCleaners(this);

    this.list.forEach((booster) => {
        booster.stop();
    });

    this.setActive(undefined);
};

FieldBoosters.prototype.onTouchBegan = function (booster) {
    if (Game.currentGame.counter.isActive()) {
        return;
    }

    if (this.active === booster) {
        this.setActive(undefined);
    } else if (booster.canExecute()) {
        booster.setUseType(cleverapps.EVENTS.BOOSTERS_USE_TYPE.USER);
        this.setActive(booster);
    } else if (booster.isAdsAvailable()) {
        cleverapps.rewardedAdsManager.playRewarded(booster.limit, () => {
            cleverapps.boosters.add(booster.id, 1);
            booster.setUseType(cleverapps.EVENTS.BOOSTERS_USE_TYPE.ADS);
            this.setActive(booster);
        });
    } else if (booster.buy()) {
        booster.setUseType(cleverapps.EVENTS.BOOSTERS_USE_TYPE.HARD);
        this.setActive(booster);
    }

    return true;
};

FieldBoosters.prototype.onTouchMoved = function (touch) {
    const cell = Game.currentGame.field.onGetView().getTouchedCell(touch);
    this.moveThrottled(cell);
};

FieldBoosters.prototype.moveThrottled = cleverapps.timeredThrottle(300, function (cell) {
    if (this.active) {
        this.active.onFieldTouchMoved(cell);
    }
});

FieldBoosters.prototype.onTouchEnded = function (targetCell) {
    if (this.active) {
        this.setActive(undefined, targetCell);
    }
};

FieldBoosters.prototype.onTouchOut = function (booster, targetCell) {
    if (Game.currentGame.counter.isActive()) {
        return;
    }

    if (cleverapps.tutorial.isActive() && this.active && !this.active.isAllowedTarget(targetCell)) {
        return; 
    }

    if (this.active === booster) {
        this.setActive(undefined, targetCell);

        return true;
    }
};

FieldBoosters.prototype.amountAvailable = function () {
    let amount = 0;
    this.list.forEach((booster) => {
        if (!booster.isDisabled()) {
            amount++;
        }
    });
    return amount;
};

FieldBoosters.prototype.listAll = function () {
    return this.list;
};

FieldBoosters.prototype.setActive = function (booster, targetCell) {
    if (this.active === booster) {
        return;
    }

    if (!booster && !targetCell && this.active && cleverapps.tutorial.isActive()) {
        return;
    }

    if (this.active) {
        this.freeFocus && this.freeFocus();

        this.active.execute(targetCell);

        cleverapps.availableMove.resume("boosters");
        this.active.deactivate();
    }

    this.active = booster;

    if (this.active) {
        cleverapps.focusManager.display({
            focus: "boosterDragging",
            stack: true,
            action: function (f) {
                cleverapps.focusManager.setEventNodes([this.active.onGetView()]);
                this.freeFocus = f;

                cleverapps.tutorial.trigger("boosterActivation");
            }.bind(this)
        });

        cleverapps.availableMove.pause("boosters");
        Game.currentGame.field.removeSelection();
        this.active.onActivateListener();
    }

    this.onSetActiveListener();
};
